<template>
  <v-card 
    :to="{ path: `/news/${news.id}` }" 
    class="news-card app-card h-100"
    elevation="0"
  >
    <v-img
      :src="news.image"
      height="240"
      cover
      class="news-image"
    >
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </v-row>
      </template>
      <div class="news-type-badge">
        <v-chip
          size="small"
          :color="getTypeColor(news.type)"
          class="text-uppercase"
        >
          {{ $t(`news.categories.${news.type}`) }}
        </v-chip>
      </div>
    </v-img>

    <v-card-text class="pa-4">
      <div class="d-flex align-center mb-2">
        <v-icon size="small" color="primary" class="mr-1">mdi-calendar</v-icon>
        <span class="text-caption text-medium-emphasis">{{ news.date }}</span>
      </div>
      <h3 class="text-h6 mb-2 text-truncate-2">{{ news.title }}</h3>
      <p class="text-body-2 text-medium-emphasis text-truncate-3">{{ news.summary }}</p>
    </v-card-text>

    <v-card-actions class="pa-4 pt-0">
      <v-spacer></v-spacer>
      <v-btn
        variant="text"
        color="primary"
        class="text-none px-0"
      >
        {{ $t('news.readMore') }}
        <v-icon end>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup lang="ts">
import type { NewsItem } from '../types/news';
import { useI18n } from 'vue-i18n';

defineProps<{
  news: NewsItem;
}>();

// 获取新闻类型对应的颜色
const getTypeColor = (type: string) => {
  const colors = {
    company: 'primary',
    industry: 'secondary',
    product: 'accent'
  };
  return colors[type as keyof typeof colors] || 'primary';
};
</script>

<style scoped>
.news-card {
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.news-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1) !important;
  border-color: rgba(var(--v-theme-primary), 0.2);
}

.news-image {
  position: relative;
  overflow: hidden;
}

.news-type-badge {
  position: absolute;
  top: 16px;
  left: 16px;
}

.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-truncate-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 响应式调整 */
@media (max-width: 600px) {
  .news-image {
    height: 200px !important;
  }
}
</style> 